import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthContext, AuthProvider } from './components/AuthContext';
import RequireAuth from './components/RequireAuth';
import { useContext } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css'
import LoginPage from './components/LoginPage';
import { BrowserRouter, Navigate } from 'react-router';
import Welcome from './components/Welcome';
import FranchiseePlatformRoutes from './components/routes/FranchiseePlatformRoutes';
import WelcomePage from './components/WelcomePage';

const App = () => {





  return (
   

      <BrowserRouter>

        <Routes>
          <Route exact path="/" element={<WelcomePage />} />
          <Route exact
            path="/login"
            element={<AuthProvider><LoginPage /></AuthProvider>}
          />
    <Route path="/*" element={<AuthProvider><FranchiseePlatformRoutes/></AuthProvider>} />
        
        </Routes>
      </BrowserRouter>



   
  );
};

export default App;